import { render, staticRenderFns } from "./PastProjectListView.vue?vue&type=template&id=647acad3&"
import script from "./PastProjectListView.vue?vue&type=script&lang=ts&"
export * from "./PastProjectListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('647acad3')) {
      api.createRecord('647acad3', component.options)
    } else {
      api.reload('647acad3', component.options)
    }
    module.hot.accept("./PastProjectListView.vue?vue&type=template&id=647acad3&", function () {
      api.rerender('647acad3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/organization/past-project/PastProjectListView.vue"
export default component.exports